/**
 * SpendNatureDecouple applier.
 *
 * Decrements active player's natureTokens by 1.
 * Sets market.decoupleUnlockedThisTurn = true.
 * Phase stays "marketCheck".
 *
 * Spec §6.3.
 */

import type { SpendNatureDecoupleAction } from "../types/actions";
import type { GameState } from "../types/game-state";
import { bumpVersion } from "./common-applier";

export const applySpendNatureDecouple = (
  state: GameState,
  _action: SpendNatureDecoupleAction,
): GameState => {
  const activeSeat = state.turn.activeSeat;

  return {
    ...state,
    ...bumpVersion(state),
    market: {
      ...state.market,
      decoupleUnlockedThisTurn: true,
    },
    players: state.players.map((p) =>
      p.seat === activeSeat ? { ...p, natureTokens: p.natureTokens - 1 } : p,
    ),
  };
};
